module.exports = __webpack_public_path__ + "img/12.7f0f6fbe.png";